<template>
  <!-- RFM标准分析 -->
  <div class="member-level" style="min-width: 1106px">
    <div class="section-right-content-box">
      <!-- RFM标准分析顶部栏 -->
      <div class="top-panel">
        <div class="global-title">
          <span style="position: relative; left: -480px; top: -18px">RFM 模型分析</span>
          <div style="
                float: left;
                background-color: #fffaee;
                padding: 0px 12px;
                border-radius: 14px;
                position: relative;
                left: 120px;
                height: 30px;
                margin-top: -6px;
              ">
            <img src="@/assets/images/new_icon_waring_yellow.png" style="
                  display: inline-block;
                  float: left;
                  position: relative;
                  width: 14px;
                  height: 14px;
                  color: #ffffff;
                  margin: 9px 4px 0px 0px;
                " />
            <span class="top-panel_span" style="position: relative; top: -11px">R：最近一次购买时间</span>
            <span class="top-panel_span">F：购买次数</span>
            <span class="top-panel_span">M：购买金额</span>
          </div>
          <div style="float: right">
            <el-button @click="customBtn" type="primary">自定义参数</el-button>
            <el-button @click="exportData" type="primary">导出数据</el-button>
          </div>
          <!-- <div style="float:left;background-color:#FFFAEE;padding:0px 12px;border-radius: 14px;">
            <img

          src="@/assets/images/new_icon_waring_yellow.png"
          style="
            display: inline-block;
            float: left;
            width: 14px;
            height: 14px;
 
            color: #ffffff;
            margin: 20px 4px 0px 0px;
          "
        />
          <span class="top-panel_span">R:最近一次购买时间</span>
          <span class="top-panel_span">F:购买次数</span>
          <span class="top-panel_span">M:购买金额</span>
          </div> -->
        </div>

        <div class="headForm" style="margin-top: 20px"></div>

        <div class="top-buttons">
          <el-radio-group v-model="radio">
            <el-radio @click.native="requests(1)" :label="3" :class="{ current: mycolor === 1 }" plain>客户数/占比</el-radio>
            <el-radio plain :label="6" @click.native="requests(2)"
              :class="{ current: mycolor === 2 }">平均每次购买金额/占比</el-radio>
            <el-radio plain :label="9" @click.native="requests(3)"
              :class="{ current: mycolor === 3 }">累计购买金额/占比</el-radio>
          </el-radio-group>
        </div>
        <div class="update-time" style="color: #333">最新数据时间：{{ currentdate }}</div>
      </div>

      <!-- rfm模型列表 -->
      <div class="rfm">
        <div>
          <div style="background-color: #f9f9f9;" class="border qqq overstriking">{{ title }}</div>
          <div v-for="(item, index) in tabelDataListsss" :key="index" class="border sss">
            <div class="overstriking">{{ item.name }}</div>
            <div style="color:#666; margin-top:4px">{{ item.label }}</div>
          </div>
          <div class="border qqq red gray">列总计</div>
        </div>
        <div>
          <div class="buy">
            <div class="border qqq overstriking">F={{ Fitem.oneinfo }}<span style="color:#666; margin-top:4px">(购买{{ Fitem.oneinfo }}次)</span></div>
            <div class="border qqq overstriking gray">F={{ Fitem.twoinfo }}<span style="color:#666; margin-top:4px">(购买{{ Fitem.twoinfo }}次)</span></div>
            <div class="border qqq overstriking">F={{ Fitem.threeinfo }}<span style="color:#666; margin-top:4px">(购买{{ Fitem.threeinfo }}次)</span></div>
            <div class="border qqq overstriking gray">F={{ Fitem.fourinfo }}<span style="color:#666; margin-top:4px">(购买{{ Fitem.fourinfo }}次)</span></div>
            <div class="border qqq overstriking">F≥{{ Fitem.fiveinfo }}<span style="color:#666; margin-top:4px">(购买{{ Fitem.fiveinfo }}次)</span></div>
          </div>
          <div v-for="(item, index) in tabelData" :key="index" class="nums">
            <div v-for="(_item, _index) in item" :key="_index" class="border count">
              <div class="wrap" :class="
                _item.buyerNum == 0
                  ? 'bgone'
                  : '' || (0 < _item.buyerNum && _item.buyerNum <= 1)
                    ? 'bgtwo'
                    : '' || (1 < _item.buyerNum && _item.buyerNum <= 2)
                      ? 'bgthree'
                      : '' || _item.buyerNum > 2
                        ? 'bgfour'
                        : '' || _item.avgPrice == 0
                          ? 'bgone'
                          : '' || (0 < _item.avgPrice && _item.avgPrice <= 1)
                            ? 'bgtwo'
                            : '' || (1 < _item.avgPrice && _item.avgPrice <= 2)
                              ? 'bgthree'
                              : '' || _item.avgPrice > 2
                                ? 'bgfour'
                                : '' || _item.amount == 0
                                  ? 'bgone'
                                  : '' || (0 < _item.amount && _item.amount <= 1)
                                    ? 'bgtwo'
                                    : '' || (1 < _item.amount && _item.amount <= 2)
                                      ? 'bgthree'
                                      : '' || _item.amount > 2
                                        ? 'bgfour'
                                        : ''
              ">
                <div v-show="radio === 3">
                  <span> {{ _item.buyerNum }}人</span>
                  <div v-if="_item.customerPercent === 99.99 && _item.buyerNum != 0">
                    {{ "大于99.99%" }}
                  </div>
                  <div v-else-if="_item.customerPercent === 0 && _item.buyerNum != 0">
                    {{ "小于0.01%" }}
                  </div>
                  <div style="color:#666" v-else>(占比{{ _item.customerPercent }}%)</div>
                </div>
                <!-- <div class="note display btn" style="display:none"> -->

                <div v-show="radio === 6">
                  <span> {{ _item.avgPrice }}元</span>
                  <div style="color:#666">(占比{{ _item.avgPricePercent }}%)</div>
                </div>

                <div v-show="radio === 9">
                  <span> {{ _item.amount }}元</span>
                  <div style="color:#666">(占比{{ _item.accumulaPricePercent }}%)</div>
                </div>

                <div class="note display btn aaa"
                  v-show="_item.buyerNum != 0 && _item.avgPrice != 0 && _item.amount != 0">
                  <button v-zoom="{ from: pageName, name: '发送短信' }" @click="SendTextMessage(item, _item, index, _index)">
                    发送短信
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="nums">
            <!-- 列总计 -->
            <div v-for="(item, index) in listtwo" :key="index" class="twogary">
              <div class="border qqq" v-if="item === 99.99">
                {{ "大于99.99%" }}
              </div>
              <div class="border qqq" v-else>
                <!-- <div v-show="radio === 3"> 人 {{ item }}%</div> -->
                {{ item }}%
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="border qqq gray red">行合计</div>
          <div class="border qqq sss" v-for="(item, index) in list" :key="index">
            <div v-if="item === 99.99">{{ "大于99.99%" }}</div>
            <div v-else>{{ item }}%</div>
          </div>
        </div>
      </div>
    </div>
     <!-- 生成报表 -->
     <generate :control = 'control' 
               v-if="control" 
               @transData="(val) => (control = val)"
               @transData1 = 'getphone1'
               
               ></generate>
    <!-- 自定义参数 -->
    <el-dialog title="设置RFM参数" :visible.sync="RFMvisible" width="600px" @close="RFMvisible = false" class="addMemberDialog">
      <div style="
          background-color: #fffaee;
          padding: 12px 12px;
          border-radius: 14px;
        ">
        <img src="@/assets/images/new_icon_waring_yellow.png" style="
              position: relative;
              width: 14px;
              height: 14px;
              color: #ffffff;
              margin-top: 3px;
              margin-right: 5px;
            " />
        <span>修改参数后不会马上生效，需要等待下次数据更新时间</span>
      </div>
      <div class="RFMBox">
        <div>R：最近一次购买时间</div>
        <div class="RFMBox-top">
          <span style="color:#000">0</span>&nbsp; - &nbsp;
          <el-input style="width:70px" :value="Ritem.oneinfo" @input='e => Ritem.oneinfo = validSe (e)' @change="handleRFM()" ></el-input>&nbsp; -
          &nbsp;<el-input style="width:70px" :value="Ritem.twoinfo"  @input='e => Ritem.twoinfo = validSe (e)' @change="handleRFM()" ></el-input>&nbsp; -
          &nbsp;<el-input style="width:70px" :value="Ritem.threeinfo" @input='e => Ritem.threeinfo = validSe (e)'  @change="handleRFM()"></el-input>&nbsp; -
          &nbsp;<el-input style="width:70px" :value="Ritem.fourinfo" @input='e => Ritem.fourinfo = validSe (e)' @change="handleRFM()" ></el-input>&nbsp;
        </div>
        <div class="RFMBox-top">
          R≤{{ Ritem.oneinfo == "0" ? "" : Ritem.oneinfo }}，{{ Ritem.oneinfo == "0" ? "" : Ritem.oneinfo }}＜R≤{{ Ritem.twoinfo }}，{{
            Ritem.twoinfo
          }}＜R≤{{ Ritem.threeinfo }}，{{ Ritem.threeinfo }}＜R≤{{ Ritem.fourinfo }}，R＞{{ Ritem.fourinfo }}
        </div>
      </div>
      <div class="RFMBox">
        <div>F：购买次数</div>
        <div class="RFMBox-top">
          <el-input style="width:70px" :value="Fitem.oneinfo"   @input='e => Fitem.oneinfo = validSe (e)'  @change="handleRFM(0)"></el-input>&nbsp; - &nbsp;
          <el-input style="width:70px" :value="Fitem.twoinfo"   @input='e => Fitem.twoinfo = validSe (e)'  @change="handleRFM(1)"></el-input>&nbsp; - &nbsp;
          <el-input style="width:70px" :value="Fitem.threeinfo" @input='e => Fitem.threeinfo = validSe (e)'  @change="handleRFM(2)" ></el-input>&nbsp; - &nbsp;
          <el-input style="width:70px" :value="Fitem.fourinfo"  @input='e => Fitem.fourinfo = validSe (e)' @change="handleRFM(3)" ></el-input>&nbsp; - &nbsp;
          <el-input style="width:70px" :value="Fitem.fiveinfo"  @input='e => Fitem.fiveinfo = validSe (e)' @change="handleRFM(4)" ></el-input>
        </div>
        <div class="RFMBox-top">F={{ Fitem.oneinfo }}，F={{ Fitem.twoinfo }}，F={{ Fitem.threeinfo }}，F={{ Fitem.fourinfo }}，F≥{{ Fitem.fiveinfo }}</div>
      </div>
      <div class="RFMBox">
        <div>M：购买金额</div>
        <div class="RFMBox-top">
          <el-input style="width:70px" :value="Mitem.oneinfo"   @input='e => Mitem.oneinfo = validSe (e,1)' @change="handleRFM()" ></el-input>&nbsp; - &nbsp;
          <el-input style="width:70px" :value="Mitem.twoinfo"   @input='e => Mitem.twoinfo = validSe (e)' @change="handleRFM()"></el-input>
        </div>
        <div class="RFMBox-top">
          {{ Mitem.oneinfo == "0" ? "" : Mitem.oneinfo }}＜M≤{{ Mitem.twoinfo }}
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="cancel_Btn" @click="RFMvisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSave()" class="sure_Btn">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { RFM_Standard_Analyse,rfmExport,getAnalyse,analyseconfig } from "@/api/analysis/rfmStandard";
import generate from '../../components/generate_report.vue'
import { mapState } from "vuex";
export default {
  name: "rfm-standard",
  computed: {
    ...mapState({
      changeColor: "globalBG",
      //   把city映射给currentCIty
    }),
  },
  data() {
    return {
      control:false,
      pageName: "数据分析-RFM标准分析",
      indexs: 0,
      isShow: false,
      radio: 3,
      mycolor: 1,
      title: "RFM模型",
      tabelData: [],
      tabelDataList: {},
      tabelDataListsss: [
        { name: "R≤30天", label: "(近30天有交易)" },
        { name: "30<R≤90天", label: "(近30-90天内有交易)" },
        { name: "90<R≤180", label: "(近90-180天有交易)" },
        { name: "180<R≤360", label: "(近180-360天内有交易)" },
        { name: "R>360", label: "(360天前有交易)" },
      ],
      list: [],
      listtwo: [],
      currentdate: "",
      customerOne: "",
      Ritem: {
        oneinfo: "30",
        twoinfo: "90",
        threeinfo: "180",
        fourinfo: "360",
      },
      Fitem: {
        oneinfo: "1",
        twoinfo: "2",
        threeinfo: "3",
        fourinfo: "4",
        fiveinfo: "5",
      },
      Mitem: {
        oneinfo: "0.01",
        twoinfo: "1000",
      },
      RFMvisible: false,
    };
  },
  components: {
    generate
  },
  created() {
    // 埋点
    this.buriedPoint(1, 'RFM模型分析', '数据分析', 'RFM分析')
  },
  mounted() {
    this.getConfig();
    this.requests(1);
    this.dateFormat();
  },
  watch: {
    RFMvisible(newVal) {
      this.getConfig();
    },
  },
  methods: {
    // 自定义参数
    customBtn() {
      this.RFMvisible = true
    },
    async getConfig() {
      const { data } = await getAnalyse({ type: 2, source: 1 })
      this.Ritem.oneinfo = data.payDateCondition[1]
      this.Ritem.twoinfo = data.payDateCondition[2]
      this.Ritem.threeinfo = data.payDateCondition[3]
      this.Ritem.fourinfo = data.payDateCondition[4]
      this.Fitem.oneinfo = data.payTimeCondition[0]
      this.Fitem.twoinfo = data.payTimeCondition[1]
      this.Fitem.threeinfo = data.payTimeCondition[2]
      this.Fitem.fourinfo = data.payTimeCondition[3]
      this.Fitem.fiveinfo = data.payTimeCondition[4]
      this.Mitem.oneinfo = data.payAmountCondition[0]
      this.Mitem.twoinfo = data.payAmountCondition[1]
      this.tabelDataListsss = [
        { name: `R≤${this.Ritem.oneinfo}天`, label: `(近${this.Ritem.oneinfo}天有交易)` },
        { name: `${this.Ritem.oneinfo}<R≤${this.Ritem.twoinfo}天`, label: `(近${this.Ritem.oneinfo}-${this.Ritem.twoinfo}天内有交易)` },
        { name: `${this.Ritem.twoinfo}<R≤${this.Ritem.threeinfo}`, label: `(近${this.Ritem.twoinfo}-${this.Ritem.threeinfo}天有交易)` },
        { name: `${this.Ritem.threeinfo}<R≤${this.Ritem.fourinfo}`, label: `(近${this.Ritem.threeinfo}-${this.Ritem.fourinfo}天内有交易)` },
        { name: `R>${this.Ritem.fourinfo}`, label: `(${this.Ritem.fourinfo}天前有交易)` },
      ]
    },

    handleRFM(index) {
      const num1 = Number(this.Ritem.oneinfo);
      const num2 = Number(this.Ritem.twoinfo);
      const num3 = Number(this.Ritem.threeinfo);
      const num4 = Number(this.Ritem.fourinfo);
      const fnum1 = Number(this.Fitem.oneinfo);
      const fnum2 = Number(this.Fitem.twoinfo);
      const fnum3 = Number(this.Fitem.threeinfo);
      const fnum4 = Number(this.Fitem.fourinfo);
      const fnum5 = Number(this.Fitem.fiveinfo);
      const mnum1 = Number(this.Mitem.oneinfo);
      const mnum2 = Number(this.Mitem.twoinfo);
      const mnum3 = Number(this.Mitem.threeinfo);
      const mnum4 = Number(this.Mitem.fourinfo);
      // Ritem
      if (num1 >= num2 && this.Ritem.oneinfo && this.Ritem.twoinfo) {
        this.Ritem.twoinfo = "";
        this.$message.warning("需要逐渐递增，不能相等");
      }
      if (num2 >= num3 && this.Ritem.twoinfo && this.Ritem.threeinfo) {
        this.Ritem.threeinfo = "";
        this.$message.warning("需要逐渐递增，不能相等");
      }
      if (num3 >= num4 && this.Ritem.threeinfo && this.Ritem.fourinfo) {
        this.Ritem.fourinfo = "";
        this.$message.warning("需要逐渐递增，不能相等");
      }
      // Fitem
      if (this.Fitem.threeinfo && this.Fitem.oneinfo && this.Fitem.twoinfo && this.Fitem.fourinfo && this.Fitem.fiveinfo) {
        const fnum = [fnum1, fnum2, fnum3, fnum4, fnum5];
        const fnumlist = [...new Set(fnum)];
        if (fnumlist.length != 5) {
          let infoList = ['oneinfo','twoinfo','threeinfo','fourinfo','fiveinfo'];
          this.Fitem[infoList[index]] = '';
          this.$message.warning("值不能相等");
        }
      }
      // Mitem
      if (mnum1 >= mnum2 && this.Mitem.oneinfo && this.Mitem.twoinfo) {
        this.Mitem.twoinfo = "";
        this.$message.warning("需要逐渐递增，不能相等");
      }
      if (mnum2 >= mnum3 && this.Mitem.twoinfo && this.Mitem.threeinfo) {
        this.Mitem.threeinfo = "";
        this.$message.warning("需要逐渐递增，不能相等");
      }
      if (mnum3 >= mnum4 && this.Mitem.threeinfo && this.Mitem.fourinfo) {
        this.Mitem.fourinfo = "";
        this.$message.warning("需要逐渐递增，不能相等");
      }
    },

    async handleSave() {
      // Fitem
      if (this.Fitem.threeinfo && this.Fitem.oneinfo && this.Fitem.twoinfo && this.Fitem.fourinfo && this.Fitem.fiveinfo) {
        const fnum = [this.Fitem.threeinfo, this.Fitem.oneinfo, this.Fitem.twoinfo, this.Fitem.fourinfo, this.Fitem.fiveinfo];
        const fnumlist = [...new Set(fnum)];
        if (fnumlist.length != 5) {
          return this.$message.warning("F：购买次数的值不能相等");
        }
      }
      if (!this.Ritem.oneinfo || !this.Ritem.twoinfo || !this.Ritem.threeinfo || !this.Ritem.fourinfo) {
        this.$message.warning("请将最近一次购买时间填写完整");
        return;
      }
      if (!this.Fitem.oneinfo || !this.Fitem.twoinfo || !this.Fitem.threeinfo || !this.Fitem.fourinfo || !this.Fitem.fiveinfo) {
        this.$message.warning("请将购买次数填写完整");
        return;
      }
      if (!this.Mitem.oneinfo || !this.Mitem.twoinfo) {
        this.$message.warning("请将购买金额填写完整");
        return;
      }
      const params = {
        payDateCondition: `0,${this.Ritem.oneinfo},${this.Ritem.twoinfo},${this.Ritem.threeinfo},${this.Ritem.fourinfo}`,
        payTimeCondition: `${this.Fitem.oneinfo},${this.Fitem.twoinfo},${this.Fitem.threeinfo},${this.Fitem.fourinfo},${this.Fitem.fiveinfo}`,
        payAmountCondition: `${this.Mitem.oneinfo},${this.Mitem.twoinfo}`,
        source: 1,
      };
      this.RFMvisible = false;
      const res = await analyseconfig(params);
      if (res.code == 1) {
        this.$message.success('保存成功！');
        this.requests();
        this.getConfig()
      } else {
        this.$message.warning(res.message);
      }
    },

    validSe(data,type = 0){
      let filtered = data.replace(/[^\d]/g, "");
      if(type = 0){
        if (Number(filtered) < 1) {
        filtered = "";
        }
      }
      return filtered
    },
   exportData() {
     this.control = true
   }, 
   getphone1(val){
    let parmas = {
        exportRemark:val
     }
    rfmExport(parmas).then((res)=>{
         if(res.code==1){
          this.control = true
         }else{
          this.$message.error(res.message);
         }
      })

    },
    //获得当前时间
    dateFormat() {
      var date = new Date();
      console.log(date);
      var seperator1 = "-";
      var seperator2 = " ";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      var hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
      var minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      var seconds = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var currentdate = year + seperator1 + month + seperator1 + strDate + " " + hours + ":" + minutes + ":" + seconds;
      this.currentdate = currentdate;

      // this.$refs.searchForm.submitForm("formSearch");
    },
    requests(num) {
      console.log(num);
      if (num === 1) {
        this.title = "RFM模型";
        RFM_Standard_Analyse().then((res) => {
          console.log(res);
          this.tabelData = res.data.customer;
          let sum1 = 0;
          let sum2 = 0;
          let sum3 = 0;
          let sum4 = 0;
          let sum5 = 0;
          let sum6 = 0;
          let sum7 = 0;
          let sum8 = 0;
          let sum9 = 0;
          let sum10 = 0;
          let sum11 = 100;
          let a10 = res.data.customer[1][0].customerPercent;
          let a11 = res.data.customer[1][1].customerPercent;
          let a12 = res.data.customer[1][2].customerPercent;
          let a13 = res.data.customer[1][3].customerPercent;
          let a14 = res.data.customer[1][4].customerPercent;
          let a20 = res.data.customer[2][0].customerPercent;
          let a21 = res.data.customer[2][1].customerPercent;
          let a22 = res.data.customer[2][2].customerPercent;
          let a23 = res.data.customer[2][3].customerPercent;
          let a24 = res.data.customer[2][4].customerPercent;
          let a30 = res.data.customer[3][0].customerPercent;
          let a31 = res.data.customer[3][1].customerPercent;
          let a32 = res.data.customer[3][2].customerPercent;
          let a33 = res.data.customer[3][3].customerPercent;
          let a34 = res.data.customer[3][4].customerPercent;
          let a40 = res.data.customer[4][0].customerPercent;
          let a41 = res.data.customer[4][1].customerPercent;
          let a42 = res.data.customer[4][2].customerPercent;
          let a43 = res.data.customer[4][3].customerPercent;
          let a44 = res.data.customer[4][4].customerPercent;
          let a50 = res.data.customer[5][0].customerPercent;
          let a51 = res.data.customer[5][1].customerPercent;
          let a52 = res.data.customer[5][2].customerPercent;
          let a53 = res.data.customer[5][3].customerPercent;
          let a54 = res.data.customer[5][4].customerPercent;
          sum1 = (a10 * 100 + a11 * 100 + a12 * 100 + a13 * 100 + a14 * 100) / 100;
          sum2 = (a20 * 100 + a21 * 100 + a22 * 100 + a23 * 100 + a24 * 100) / 100;
          sum3 = (a30 * 100 + a31 * 100 + a32 * 100 + a33 * 100 + a34 * 100) / 100;
          sum4 = (a40 * 100 + a41 * 100 + a42 * 100 + a43 * 100 + a44 * 100) / 100;
          sum5 = (a50 * 100 + a51 * 100 + a52 * 100 + a53 * 100 + a54 * 100) / 100;
          // sum11 = sum1 + sum2 + sum3 + sum4 + sum5;
          sum1 = sum1.toString().length > 5 ? sum1.toFixed(2) : sum1;
          sum2 = sum2.toString().length > 5 ? sum2.toFixed(2) : sum2;
          sum3 = sum3.toString().length > 5 ? sum3.toFixed(2) : sum3;
          sum4 = sum4.toString().length > 5 ? sum4.toFixed(2) : sum4;
          sum5 = sum5.toString().length > 5 ? sum5.toFixed(2) : sum5;
          this.list = [sum1, sum2, sum3, sum4, sum5, sum11];
          sum6 = (a10 * 100 + a20 * 100 + a30 * 100 + a40 * 100 + a50 * 100) / 100;
          sum7 = (a11 * 100 + a21 * 100 + a31 * 100 + a41 * 100 + a51 * 100) / 100;
          sum8 = (a12 * 100 + a22 * 100 + a32 * 100 + a42 * 100 + a52 * 100) / 100;
          sum9 = (a13 * 100 + a23 * 100 + a33 * 100 + a43 * 100 + a53 * 100) / 100;
          sum10 = (a14 * 100 + a24 * 100 + a34 * 100 + a44 * 100 + a54 * 100) / 100;
          sum6 = sum6.toString().length > 5 ? sum6.toFixed(2) : sum6;
          sum7 = sum7.toString().length > 5 ? sum7.toFixed(2) : sum7;
          sum8 = sum8.toString().length > 5 ? sum8.toFixed(2) : sum8;
          sum9 = sum9.toString().length > 5 ? sum9.toFixed(2) : sum9;
          sum10 = sum10.toString().length > 5 ? sum10.toFixed(2) : sum10;
          this.listtwo = [sum6, sum7, sum8, sum9, sum10];
        });
      }
      if (num === 2) {
        this.title = "RFM模型=平均购买金额";

        RFM_Standard_Analyse().then((res) => {
          this.tabelData = res.data.avgPrice;
          let sum1 = 0;
          let sum2 = 0;
          let sum3 = 0;
          let sum4 = 0;
          let sum5 = 0;
          let sum6 = 0;
          let sum7 = 0;
          let sum8 = 0;
          let sum9 = 0;
          let sum10 = 0;
          let sum11 = 100;
          let a10 = res.data.avgPrice[1][0].avgPricePercent;
          let a11 = res.data.avgPrice[1][1].avgPricePercent;
          let a12 = res.data.avgPrice[1][2].avgPricePercent;
          let a13 = res.data.avgPrice[1][3].avgPricePercent;
          let a14 = res.data.avgPrice[1][4].avgPricePercent;
          let a20 = res.data.avgPrice[2][0].avgPricePercent;
          let a21 = res.data.avgPrice[2][1].avgPricePercent;
          let a22 = res.data.avgPrice[2][2].avgPricePercent;
          let a23 = res.data.avgPrice[2][3].avgPricePercent;
          let a24 = res.data.avgPrice[2][4].avgPricePercent;
          let a30 = res.data.avgPrice[3][0].avgPricePercent;
          let a31 = res.data.avgPrice[3][1].avgPricePercent;
          let a32 = res.data.avgPrice[3][2].avgPricePercent;
          let a33 = res.data.avgPrice[3][3].avgPricePercent;
          let a34 = res.data.avgPrice[3][4].avgPricePercent;
          let a40 = res.data.avgPrice[4][0].avgPricePercent;
          let a41 = res.data.avgPrice[4][1].avgPricePercent;
          let a42 = res.data.avgPrice[4][2].avgPricePercent;
          let a43 = res.data.avgPrice[4][3].avgPricePercent;
          let a44 = res.data.avgPrice[4][4].avgPricePercent;
          let a50 = res.data.avgPrice[5][0].avgPricePercent;
          let a51 = res.data.avgPrice[5][1].avgPricePercent;
          let a52 = res.data.avgPrice[5][2].avgPricePercent;
          let a53 = res.data.avgPrice[5][3].avgPricePercent;
          let a54 = res.data.avgPrice[5][4].avgPricePercent;
          sum1 = (a10 * 100 + a11 * 100 + a12 * 100 + a13 * 100 + a14 * 100) / 100;
          sum2 = (a20 * 100 + a21 * 100 + a22 * 100 + a23 * 100 + a24 * 100) / 100;
          sum3 = (a30 * 100 + a31 * 100 + a32 * 100 + a33 * 100 + a34 * 100) / 100;
          sum4 = (a40 * 100 + a41 * 100 + a42 * 100 + a43 * 100 + a44 * 100) / 100;
          sum5 = (a50 * 100 + a51 * 100 + a52 * 100 + a53 * 100 + a54 * 100) / 100;
          // sum11 = sum1 + sum2 + sum3 + sum4 + sum5;
          sum1 = sum1.toString().length > 5 ? sum1.toFixed(2) : sum1;
          sum2 = sum2.toString().length > 5 ? sum2.toFixed(2) : sum2;
          sum3 = sum3.toString().length > 5 ? sum3.toFixed(2) : sum3;
          sum4 = sum4.toString().length > 5 ? sum4.toFixed(2) : sum4;
          sum5 = sum5.toString().length > 5 ? sum5.toFixed(2) : sum5;
          this.list = [sum1, sum2, sum3, sum4, sum5, sum11];
          sum6 = (a10 * 100 + a20 * 100 + a30 * 100 + a40 * 100 + a50 * 100) / 100;
          sum7 = (a11 * 100 + a21 * 100 + a31 * 100 + a41 * 100 + a51 * 100) / 100;
          sum8 = (a12 * 100 + a22 * 100 + a32 * 100 + a42 * 100 + a52 * 100) / 100;
          sum9 = (a13 * 100 + a23 * 100 + a33 * 100 + a43 * 100 + a53 * 100) / 100;
          sum10 = (a14 * 100 + a24 * 100 + a34 * 100 + a44 * 100 + a54 * 100) / 100;
          // console.log(sum9, sum9.toString().length, sum9.toString().length > 5);
          sum6 = sum6.toString().length > 5 ? sum6.toFixed(2) : sum6;
          sum7 = sum7.toString().length > 5 ? sum7.toFixed(2) : sum7;
          sum8 = sum8.toString().length > 5 ? sum8.toFixed(2) : sum8;
          sum9 = sum9.toString().length > 5 ? sum9.toFixed(2) : sum9;
          sum10 = sum10.toString().length > 5 ? sum10.toFixed(2) : sum10;
          this.listtwo = [sum6, sum7, sum8, sum9, sum10];
        });
      }
      if (num === 3) {
        this.title = "RFM模型=累计购买金额";
        RFM_Standard_Analyse().then((res) => {
          this.tabelData = res.data.accumulaPrice;
          let sum1 = 0;
          let sum2 = 0;
          let sum3 = 0;
          let sum4 = 0;
          let sum5 = 0;
          let sum6 = 0;
          let sum7 = 0;
          let sum8 = 0;
          let sum9 = 0;
          let sum10 = 0;
          let sum11 = 100;
          let a10 = res.data.accumulaPrice[1][0].accumulaPricePercent;
          let a11 = res.data.accumulaPrice[1][1].accumulaPricePercent;
          let a12 = res.data.accumulaPrice[1][2].accumulaPricePercent;
          let a13 = res.data.accumulaPrice[1][3].accumulaPricePercent;
          let a14 = res.data.accumulaPrice[1][4].accumulaPricePercent;
          let a20 = res.data.accumulaPrice[2][0].accumulaPricePercent;
          let a21 = res.data.accumulaPrice[2][1].accumulaPricePercent;
          let a22 = res.data.accumulaPrice[2][2].accumulaPricePercent;
          let a23 = res.data.accumulaPrice[2][3].accumulaPricePercent;
          let a24 = res.data.accumulaPrice[2][4].accumulaPricePercent;
          let a30 = res.data.accumulaPrice[3][0].accumulaPricePercent;
          let a31 = res.data.accumulaPrice[3][1].accumulaPricePercent;
          let a32 = res.data.accumulaPrice[3][2].accumulaPricePercent;
          let a33 = res.data.accumulaPrice[3][3].accumulaPricePercent;
          let a34 = res.data.accumulaPrice[3][4].accumulaPricePercent;
          let a40 = res.data.accumulaPrice[4][0].accumulaPricePercent;
          let a41 = res.data.accumulaPrice[4][1].accumulaPricePercent;
          let a42 = res.data.accumulaPrice[4][2].accumulaPricePercent;
          let a43 = res.data.accumulaPrice[4][3].accumulaPricePercent;
          let a44 = res.data.accumulaPrice[4][4].accumulaPricePercent;
          let a50 = res.data.accumulaPrice[5][0].accumulaPricePercent;
          let a51 = res.data.accumulaPrice[5][1].accumulaPricePercent;
          let a52 = res.data.accumulaPrice[5][2].accumulaPricePercent;
          let a53 = res.data.accumulaPrice[5][3].accumulaPricePercent;
          let a54 = res.data.accumulaPrice[5][4].accumulaPricePercent;
          sum1 = (a10 * 100 + a11 * 100 + a12 * 100 + a13 * 100 + a14 * 100) / 100;
          sum2 = (a20 * 100 + a21 * 100 + a22 * 100 + a23 * 100 + a24 * 100) / 100;
          sum3 = (a30 * 100 + a31 * 100 + a32 * 100 + a33 * 100 + a34 * 100) / 100;
          sum4 = (a40 * 100 + a41 * 100 + a42 * 100 + a43 * 100 + a44 * 100) / 100;
          sum5 = (a50 * 100 + a51 * 100 + a52 * 100 + a53 * 100 + a54 * 100) / 100;
          // sum11 = sum1 + sum2 + sum3 + sum4 + sum5;
          sum1 = sum1.toString().length > 5 ? sum1.toFixed(2) : sum1;
          sum2 = sum2.toString().length > 5 ? sum2.toFixed(2) : sum2;
          sum3 = sum3.toString().length > 5 ? sum3.toFixed(2) : sum3;
          sum4 = sum4.toString().length > 5 ? sum4.toFixed(2) : sum4;
          sum5 = sum5.toString().length > 5 ? sum5.toFixed(2) : sum5;
          this.list = [sum1, sum2, sum3, sum4, sum5, sum11];
          sum6 = (a10 * 100 + a20 * 100 + a30 * 100 + a40 * 100 + a50 * 100) / 100;
          sum7 = (a11 * 100 + a21 * 100 + a31 * 100 + a41 * 100 + a51 * 100) / 100;
          sum8 = (a12 * 100 + a22 * 100 + a32 * 100 + a42 * 100 + a52 * 100) / 100;
          sum9 = (a13 * 100 + a23 * 100 + a33 * 100 + a43 * 100 + a53 * 100) / 100;
          sum10 = (a14 * 100 + a24 * 100 + a34 * 100 + a44 * 100 + a54 * 100) / 100;

          sum6 = sum6.toString().length > 5 ? sum6.toFixed(2) : sum6;
          sum7 = sum7.toString().length > 5 ? sum7.toFixed(2) : sum7;
          sum8 = sum8.toString().length > 5 ? sum8.toFixed(2) : sum8;
          sum9 = sum9.toString().length > 5 ? sum9.toFixed(2) : sum9;
          sum10 = sum10.toString().length > 5 ? sum10.toFixed(2) : sum10;
          this.listtwo = [sum6, sum7, sum8, sum9, sum10];
        });
      }
    },
    SendTextMessage(a, b, day, number) {
      console.log(day, number);
      let routeUrl = this.$router.resolve({
        path: "/marketing/marketing/member_send",
        query: {
          tabIndex: 1,
          day,
          number,
        },
      });
      window.open(routeUrl.href, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
.bgfour {
  background-color: #fb9d9d;
}

.bgthree {
  background-color: #fcb5b5;
}

.bgtwo {
  background-color: #fdcece;
}

.bgone {
  background-color: #fee6e6;
}

.gray {
  background-color: #f9f9f9;
}

.twogary {
  &:nth-child(2n) {
    background-color: #f9f9f9 !important;
  }
}

/deep/ .el-radio__inner {
  width: 12px;
  height: 12px;
  background: #ffffff;
  border: 2px solid #dddddd;
  opacity: 1;
  border-radius: 6px;
}

/deep/.el-radio__input.is-checked+.el-radio__label {
  color: #333;
}

/deep/ .el-radio__input.is-checked .el-radio__inner {
  width: 12px;
  height: 12px;
  background: #ffffff;
  border: 3px solid #fe4d45;
  opacity: 1;
  border-radius: 6px;
}

/deep/ .el-radio__label {
  font-size: 14px;
  padding-left: 10px;
  color: #333;
  background-color: #ffffff;
}

* {
  font-family: "Microsoft YaHei";
}

@mixin translateX($number) {
  -webkit-transform: translateX($number);
  -moz-transform: translateX($number);
  -ms-transform: translateX($number);
  -o-transform: translateX($number);
  transform: translateX($number);
}

@mixin translateY($number) {
  -webkit-transform: translateY($number);
  -moz-transform: translateY($number);
  -ms-transform: translateY($number);
  -o-transform: translateY($number);
  transform: translateY($number);
}

@mixin translate($number, $number2) {
  -webkit-transform: translateX($number) translateY($number2);
  -moz-transform: translateX($number) translateY($number2);
  -ms-transform: translateX($number) translateY($number2);
  -o-transform: translateX($number) translateY($number2);
  transform: translateX($number) translateY($number2);
}

.section-right-content-box {
  background-color: #fff;
  /*box-shadow: 0px 8px 20px rgba(139, 156, 188, 0.16);*/
  -webkit-border-radius: 8px;
  -moz-border-radius: 8px;
  border-radius: 8px;
  padding: 33px 30px 16px 30px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  border: 1px solid rgba(230, 230, 230, 1);
  opacity: 1;
  margin: 11px 20px;

  .top-panel_span {
    font-size: 14px;
    margin-right: 40px;
    position: relative;
    top: -11px;
    // font-family: PingFang SC;
    font-weight: 400;
    line-height: 20px;
    color: #333333;
    opacity: 1;
  }
}

.top-panel {
  padding: 0 0 15px 0;
  overflow: hidden;

  .top-buttons {
    float: left;

    button {
      height: 32px;
      line-height: 30px;
      background-color: rgba(109, 112, 136, 0.03);
      border-color: #d1d2d9;
      color: #666666;
      font-size: 15px;
      padding: 0 16px;
      margin-right: 20px;
    }

    .current {
      // background-color: rgba(39, 112, 251, 0.1);
      // color: #2770fb;
      // border-color: #2770fb;
    }
  }

  .update-time {
    height: 30px;
    line-height: 30px;
    float: right;
    color: #333;
    font-size: 14px;
  }
}

.rfm-meaning {
  margin-top: 23px;
  // width: 459px;
  height: 34px;
  box-sizing: border-box;
  padding-left: 13px;
  line-height: 34px;
  color: #ff7600;
  background-color: rgba(255, 118, 0, 0.1);
  font-size: 14px;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  border-radius: 3px;

  span {
    padding-right: 16px;
  }
}

.row-panel {
  border: 1px solid #e1e1e6;
  margin-top: 10px;

  .col-panel {
    width: 14.2857142857%;

    .cell {
      position: relative;
      height: 85px;

      text-align: center;
      box-sizing: border-box;
      border: 1px solid #f2f2f2;

      .content-panel {
        // width: 100%;
        border: 1px solid #f2f2f2;
        height: 100%;
        box-sizing: border-box;
        padding-top: 10px;
      }

      .send-message {
        background-color: #000000;
        opacity: 0.1;
      }

      .first-title {
        display: inline-block;
        // width: 150px;
        text-align: left;

        span {
          display: inline-block;
        }
      }

      .content {
        display: inline-block;

        .content-item {
          .count {
            font-size: 16px;
            color: #2062e7;
            font-weight: bold;
          }
        }
      }

      .label {
        height: 25px;
        font-size: 14px;
        color: #333333;
        font-weight: 500;
        line-height: 25px;
      }

      .desc {
        font-size: 14px;
        color: #999999;
        line-height: 20px;
        margin-top: 8px;
      }

      .send-button {
        display: none;
        position: absolute;
        left: 50%;
        top: 50%;
        width: 86px;
        height: 30px;
        margin: -15px 0 0 -43px;
        background-color: #2770fb;
        border-color: #2770fb;
        line-height: 30px;
        font-size: 15px;
        color: #ffffff;
        padding: 0;
      }

      .show-button {
        display: block;
      }
    }

    .cell:last-child {
      border-bottom: none;
    }

    .header-cell {
      height: 85px;
      padding-top: 20px;

      span {
        font-size: 14px;
        color: #333333;
        font-weight: 500;
        line-height: 40px;
      }
    }

    .first-cell {
      padding-top: 10px;
    }
  }
}

.rfm {
  // width: 800px;
  display: flex;

  .buy {
    display: flex;
  }

  .nums {
    display: flex;

    .twogary {
      flex: 1;
    }
  }
}

.border {
  @media screen and (min-width: 1700px) and (max-width: 2000px) {
    // line-height: 68px;
    min-width: 235px;
  }

  @media screen and (min-width: 1600px) and (max-width: 1700px) {
    // line-height: 68px;
    min-width: 190px;
  }

  @media screen and (min-width: 1500px) and (max-width: 1599px) {
    // line-height: 69px;
    min-width: 175px;
  }

  @media screen and (min-width: 1400px) and (max-width: 1499px) {
    // line-height: 69px;
    min-width: 160px;
  }

  @media screen and (min-width: 1357px) and (max-width: 1399px) {
    // line-height: 69px;
    min-width: 152px;
  }

  @media screen and (min-width: 1320px) and (max-width: 1356px) {
    // line-height: 69px;
    min-width: 146px;
  }

  @media screen and (max-width: 1319px) {
    // line-height: 69px;
    min-width: 140px;
  }

  // @media screen and (max-width: 1399px) {
  //   // line-height: 70px;
  //   min-width: 237px;
  // }
  height: 90px;
  border-bottom: 1px solid #fff;
  border-right: 1px solid #fff;
  text-align: center;
}

.count {
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;

  flex-direction: column;

  span {
    color: #333333;
    font-size: 16px;
    // font-weight: bold;
    margin-bottom: 10px;
    display: block;
  }

  div {
    color: #333333;
  }
}

.qqq {
  line-height: 90px;
}

.sss {
  display: flex;
  justify-content: center;
  flex-direction: column;

  &:nth-child(2n + 1) {
    background-color: #f9f9f9;
  }
}

.overstriking {
  // font-weight: 700;
}

.red {
  color: #7f85e9;
  font-weight: 700;
  // color: #ff0000;
}

.display {
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.7);
  // opacity: 0.5;
  // filter: blur(1px);
  display: flex;
  justify-content: center;
  align-items: center;
}

.wrap {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;

  .note {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    display: flex;

    button {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      background-color: #fe4d45;
      border: 0px;
      width: 80px;
      height: 30px;
      opacity: 1;
      line-height: 30px;
      font-size: 15px;
      border-radius: 5px;
      color: #ffffff;
      padding: 0;

      &:focus {
        outline: 0;
      }
    }
  }

  .btn {
    display: none;
  }

  &:hover {
    .btn {
      display: block;
    }
  }
}
.RFMBox {
  padding: 10px 0px 25px 17px;
  color: #000;
  .RFMBox-top {
    color: #999;
    margin-left: 24px;
    margin-top: 15px;
  }
}
</style>
